import {Component, Input, OnInit} from '@angular/core';
import {NgForOf, NgIf, NgStyle} from "@angular/common";
import { environment } from '../../../../../environments/environment.development';
import {RouterLink} from "@angular/router";
import {PromotionPersonService} from "../../../promotions-person/services/promotion-person.service";
import {Observable} from "rxjs";

@Component({
  selector: 'app-promociones-especialidades',
  standalone: true,
  imports: [
    NgForOf,
    NgStyle,
    RouterLink,
    NgIf
  ],
  templateUrl: './promociones-especialidades.component.html',
  styleUrl: '../../../promotions-person/promotions-list/promotions-list.component.css'
})
export class PromocionesEspecialidadesComponent implements OnInit {
  serverImgenUrl = environment.imgUrl;
  @Input() categoria!: any;
  promotions: any[] = [];

  constructor(
    private promotionPersonService: PromotionPersonService
  ) {
  }

  ngOnInit() {
    this.promotionPersonService.filtroByCategoria(this.categoria).subscribe(
      promotions => {
        this.promotions = promotions;
      });
  }





}
